module.exports = __webpack_public_path__ + "static/avil-c429852fc53227a59819eedf98e37bdf.png";